<template>
  <div class="action-icons-container" :class="textClass">
    <icon v-if="!!backAction || !!closeAction"
          class="action-icon"
          size="24px" weight="700"
          :icon-name="!!backAction ? 'navigate_before' : 'close'"
          v-on:click="onActionClick"/>
  </div>
</template>
<script>
import Colors from '../scss/riseup-js-colors.module.scss';
import Icon from './Icon.vue';

export default {
  name: 'ModalActions',
  components: { Icon },
  props: {
    closeAction: {
      type: Function,
      require: false,
      default: null,
    },
    backAction: {
      type: Function,
      require: false,
      default: null,
    },
    darkText: {
      type: Boolean,
      require: false,
      default: null,
    },
  },
  data() {
    return {
      darkTextColor: Colors.riseupBlack,
      lightTextColor: Colors.riseupWhite,
    };
  },
  computed: {
    textClass() {
      if (this.darkText === null) {
        return '';
      }
      return this.darkText ? 'dark-text' : 'light-text';
    },
  },
  methods: {
    onActionClick() {
      if (this.backAction) {
        this.backAction();
      } else if (this.closeAction) {
        this.closeAction();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/riseup-colors";

.action-icons-container {
  position: absolute;
  display: inline-block;
  left: 11px;
  top: 11px;
  height: 22px;
  width: 100%;
  text-align: left;
  line-height: 9px;
  .action-icon {
    cursor: pointer;
  }
  &.dark-text {
    .action-icon {
      color: $riseup_gray_80;
    }
  }
  &.light-text {
    .action-icon {
      color: $riseup_white;
    }
  }
}

@each $variant, $color in $variant-to-color {
  .#{$variant} .action-icon {
    color: if(index($dark-text-variants, $variant), $riseup_gray_80, $riseup_white);
  }
}

</style>
